<template>
  <div class="privateBox">
    <div class="tab_lista">
      <div class="tab_lista_box">
        <div @click="current(1)" :class="[active == 1?'activeBor':'']">{{$t('MySpace.shopping')}}</div>
        <div @click="current(2)" :class="[active == 2?'activeBor':'']">{{$t('MySpace.dataOrder')}}</div>
        <div @click="current(3)" :class="[active == 3?'activeBor':'']">{{$t('MySpace.dataCollection')}}</div>
      </div>
    </div>
    <div class="tab_box">
      <ShopingCart v-show="active == 1"></ShopingCart>
      <Order v-show="active == 2"></Order>
      <Collect v-show="active == 3"></Collect>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 1
    };
  },
  methods: {
    current(val) {
      this.active = val;
    }
  },
  components: {
    ShopingCart: () => import("@/components/Private/ShopingCart.vue"),
    Order: () => import("@/components/Private/Order.vue"),
    Collect: () => import("@/components/Private/Collect.vue")
  }
};
</script>
<style  lang="scss">
.privateBox {
  // background: #fff;
  margin: auto;
  .tab_lista {
    padding-top: 70px;

    background: #fff;
    .tab_lista_box {
      width: 1200px;
      margin: auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      .activeBor {
        border-bottom: 4px solid #0a97d9;
        color: #0a97d9;
      }
      div {
        border-bottom: 4px solid #fff;
        padding-bottom: 16px;
        // padding: 0 27px;
        text-align: center;
        // width: 102px;
        padding: 0 20px 16px;
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
        &:hover {
          color: #0a97d9;
        }
      }
    }
  }
  .tab_box {
    width: 1200px;
    padding: 10px;
    margin: 20px auto 0;
    background: #fff;
  }
}
</style>